import React from 'react'

import { type TrayCardImage } from '../../../../../firebase/model/tray-cards/types/image-model'
import { useTrackContext } from '../../TrackPositioner/TrackPositioner'

import './FloorTrayImage.scss'

interface FloorTrayImageProps {
  trayCard: TrayCardImage
}

const FloorTrayImage = ({ trayCard }: FloorTrayImageProps) => {
  const { trackSize, setTrackSize } = useTrackContext()
  return (
    <img
      style={{
        '--imageWidth': trackSize.width,
        '--imageHeight': trackSize.height,
      }}
      onLoad={(event) => {
        setTrackSize({
          width: event.currentTarget.naturalWidth,
          height: event.currentTarget.naturalHeight,
        })
      }}
      className="floor-tray-image"
      src={trayCard.thumbnail}
      alt=""
    />
  )
}

export { FloorTrayImage }
